import React, { useState } from 'react';
import Autosuggest from 'react-autosuggest';
import { useTranslation } from 'react-i18next';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import {
  ADDRESS_AUTOCOMPLETE_TIMEOUT,
} from '../../config/constants';

import './style.scss';

const RESULT_TYPE_LOCATION = 'location';


function abortableFetch(request, opts) {
  const controller = new AbortController();
  const signal = controller.signal;

  return {
    abort: () => controller.abort(),
    ready: fetch(request, { ...opts, signal }),
  };
}

let currentFetch = null;
const ApiAutocomplete = ({ endpoint, placeholder, renderItem, defaultValue, onSelectItem, queryParameter = 'q', onEnterTakeFirstResult = false, isCta, locationsData, submitHandle, ...props }) => {
  const { t } = useTranslation();
  const [queryInput, setQuery] = useState(defaultValue || '');
  const [results, setResults] = useState([]);
  const [timeoutFn, setTimeoutFn] = useState(null);

  const getSuggestions = (query) => {
    const url = `${endpoint}?${queryParameter}=${query}`;

    if (currentFetch) {
      currentFetch.abort();
    }

    currentFetch = abortableFetch(url);
    currentFetch.ready
      .then((response) => { return response.json(); })
      .then((response) => {
        let data = [];
        const ajaxResults = response.map((item, index) => {
          item.value = index;
          return item;
        });
        if (locationsData) {
          const locationMatches = locationsData.filter((e) => {
            return e.get('title').toLowerCase().replace('-', ' ').includes(query.toLowerCase());
          });
          const locationMatchesResults = locationMatches.map((item) => {
            return {
              lon: item.getIn(['geo_location', 'lon']),
              lat: item.getIn(['geo_location', 'lat']),
              name: item.get('title'),
              type: 'location',
              value: 0,
            };
          }).toJS();
          // Combine the location matches with the API results
          const combinedResults = locationMatchesResults.slice(0, 2).concat(ajaxResults);
          data = combinedResults;
        } else {
          data = ajaxResults;
        }

        // Mark the duplicate names
        const processedResults = data.map((obj) => {
          return {
            duplicate: data.filter((e) => { return e.name === obj.name; }).length > 1,
            ...obj,
          };
        });

        setResults(processedResults);
      })
      .catch((e) => {
        // Catch the error so the browser does not output errors.
      });
  };

  // Filter out non-eligible results
  const findEligibleFirstResult = (results) => {
    // Never return a first result that has type "Location" (see: https://uncinc.monday.com/boards/1506051082/pulses/2714305175)
    const eligibleResults = results.filter((result) => { return result.type !== RESULT_TYPE_LOCATION; });
    if (eligibleResults.length > 0) {
      return eligibleResults[0];
    }
    return null;
  };

  return (
    <>
      <Autosuggest
        suggestions={results.filter((e) => {
          return e.type === 'woonplaats' || e.type === 'location' || e.type === 'postcode';
        })}
        onSuggestionsFetchRequested={({ value, reason }) => {
          if (timeoutFn) {
            clearTimeout(timeoutFn);
          }
          setTimeoutFn(setTimeout(() => {
            getSuggestions(value);
          }, ADDRESS_AUTOCOMPLETE_TIMEOUT));
        }}
        getSuggestionValue={(item) => {
          return item.name;
        }}
        renderSuggestion={(item, attributes) => {
          return renderItem(item, attributes.isHighlighted);
        }}
        onSuggestionSelected={(event, { suggestion }) => {
          onSelectItem(suggestion);
        }}
        inputProps={{
          ...props,
          placeholder,
          value: queryInput,
          onBlur: (event) => {
            const value = event.target.value;
            if (!value || value.length === 0) {
              onSelectItem('');
            }
          },
          onChange: (event, { newValue }) => {
            setQuery(newValue);
          },
          onKeyDown: (event) => {
            if (onEnterTakeFirstResult) {
              if (event.key === 'Enter') {
                const firstEligibleResult = findEligibleFirstResult(results);
                if (firstEligibleResult) {
                  // Set the result
                  onSelectItem(firstEligibleResult);
                  // Update user query with the selected result
                  setQuery(firstEligibleResult.name);
                }
              }
            }
          },
        }}
      />
      <Button
        onClick={() => {
          if (onEnterTakeFirstResult) {
            if (results.length > 0) {
              onSelectItem(results[0]);
            }
          } else {
            submitHandle();
          }
        }}
        primary
        className="Button--cta Autocomplete__holder__inner__cta"
      >
        {isCta ? (
          <div>
            <div className="mb-hidden">
              {t('general.search_plural')}
            </div>
            <div className="dt-hidden">
              <span className="icon icon-search icon-variant-1" />
            </div>
          </div>
        ) : (
          <span className="icon icon-search fixed-icon" />
        )}
      </Button>
    </>
  );
};

export default ApiAutocomplete;
